import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings } from "../../../settings";
import TensionReel from "../TensionReel/TensionReel";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import { useDimensions } from "../../../Contexts/DimensionsContext";

const TensionReelSet = memo(() => {
  const { tensionReelRefs } = useReelRefs();
  const { symbolWidth, symbolHeight, reelSpacing } = useDimensions();

  // Memoize tension reels array (constant length, only needs to be created once)
  const tensionReels = useMemo(
    () => Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
    []
  );

  return (
    <Container name="tension_overlay" zIndex={4}>
      {tensionReels.map((index) => (
        <TensionReel
          key={index}
          ref={(el) => {
            tensionReelRefs.current[index] = el;
          }}
          index={index}
          reelSpacing={reelSpacing}
          symbolWidth={symbolWidth}
          symbolHeight={symbolHeight}
        />
      ))}
    </Container>
  );
});

export default TensionReelSet;
